
// export const myGetter = ( state ) => {
//   return
// }
export const getProgram = ( state ) => {
    return state.program
}